import { CountryCode, CountryLocaleMap, USER_SELECTED_LANG_COOKIE } from '@constants'
import Cookies from 'js-cookie'
import { getCountryCodeFromPathname } from './getCountryCodeFromPathname'

const DEFAULT_LOCALE = 'zh_TW'

/**
 * 頁面內容當下的語系:使用者明示選過就用它,否則用網址路徑對應的站台語系。
 * cookie 值不做驗證,原樣回傳。
 */
export const getWordPressLocale = () => {
  try {
    if (typeof window === 'undefined') return DEFAULT_LOCALE
    const countryCode = getCountryCodeFromPathname(window.location.pathname, CountryCode.TW) as CountryCode
    const userSelectedLang = Cookies.get(USER_SELECTED_LANG_COOKIE)
    const locale = countryCode ? CountryLocaleMap[countryCode] : DEFAULT_LOCALE
    return userSelectedLang || locale
  }
  catch (error) {
    console.error('Error getting WordPress locale:', error)
    return DEFAULT_LOCALE
  }
}
